<div class="sensor-grid" *ngIf="tiles.length">
  <span class="grid-axis">{{ '@right' | translate }}</span>
  <div class="grid-bed" [class.no-cab]="!showSteeringWheel"
       [style.grid-template-rows]="rowTemplate"
       [style.grid-template-columns]="colTemplate">
    <ng-container *ngFor="let t of tiles; trackBy: trackTile">
      <button type="button"
              class="grid-tile"
              *ngIf="t.sensor; else emptyTile"
              [class.selected]="t.sensor.sensorId === selectedSensorId"
              [class.hovered]="t.sensor.sensorId === hoveredSensorId"
              (mouseenter)="sensorHover.emit(t.sensor.sensorId)"
              (mouseleave)="sensorHover.emit(null)"
              [style.grid-row]="t.row + ' / span ' + t.span"
              [style.grid-column]="t.col"
              [matTooltip]="((t.location | tirePosition:assetType) || (t.location | gridLocation) || t.location)
                            + (t.reading ? ' · ' + (t.reading.sensorValue | sensorValue:t.reading.sensorValueType) : '')"
              (click)="onSelect(t)">
        <mat-icon class="grid-tile-stale" *ngIf="t.stale" [matTooltip]="'@staleTooltip' | translate">hourglass_empty</mat-icon>
        <span class="grid-tile-dot" [ngClass]="t.sevClass">
          <span class="grid-tile-value" *ngIf="t.reading">{{ t.reading.sensorValue | number:'1.0-1' }}</span>
        </span>
      </button>

      <ng-template #emptyTile>
        <span class="grid-tile grid-tile-empty"
              [style.grid-row]="t.row + ' / span ' + t.span"
              [style.grid-column]="t.col"
              [matTooltip]="((t.location | tirePosition:assetType) || (t.location | gridLocation) || t.location) + ' · ' + ('@noSensorFitted' | translate)"></span>
      </ng-template>
    </ng-container>
  </div>
  <span class="grid-axis">{{ '@left' | translate }}</span>
</div>
